module.exports = __webpack_public_path__ + "img/user-11.889f2489.png";